var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayorEnrollmentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M360.437 386.229V470a24.036 24.036 0 0 1-24 24H42.009a24.037 24.037 0 0 1-24-24V42a24.036 24.036 0 0 1 24-24h243.643a7.981 7.981 0 0 1 6.063 2.781l66.347 66.263a7.938 7.938 0 0 1 2.352 5.656l.023 111.044 28.848-49.966 22.975-39.824a18.694 18.694 0 0 1 25.524-6.824l46.88 27.066a18.694 18.694 0 0 1 6.823 25.525L361.719 384.486a7.968 7.968 0 0 1-1.282 1.743zM215.788 134.258a37.428 37.428 0 1 0-53.132 0 73.866 73.866 0 0 0-46.734 60.64 7.984 7.984 0 0 0 7.863 9.483h130.873v-.024a8 8 0 0 0 7.942-8.757 73.839 73.839 0 0 0-46.808-61.341zm12.145 25.934a57.831 57.831 0 0 0-94.623 28.189h111.823a57.775 57.775 0 0 0-17.2-28.189zm-38.711-73.723a21.427 21.427 0 1 0 21.427 21.431 21.426 21.426 0 0 0-21.427-21.427zM80.322 264h217.8a8 8 0 0 0 0-16h-217.8a8 8 0 0 0 0 16zm0 79.492h183.412a8 8 0 0 0 0-16H80.322a8 8 0 0 0 0 16zM407.08 154.818l51.605 29.794 18.99-32.891a2.773 2.773 0 0 0-1.011-3.712l-46.88-27.066c-1.558-.9-3.009-.125-3.967 1.42zm-12.937 66.05a7.981 7.981 0 1 1 13.812 8L332.9 358.861l18.884 10.9L450.7 198.436l-51.6-29.794-98.925 171.341 18.9 10.91 75.07-130.025zM298.9 401.79l39.459-21.352-40.7-23.514zm-3.829 20.226v-.009a7.981 7.981 0 0 1-11.745-6.8l-1.985-72.087a7.917 7.917 0 0 1 1.057-4.187l62.049-107.473V100.7h-42.792a24.037 24.037 0 0 1-24-24V34H42.009a8.033 8.033 0 0 0-8 8v428a8.032 8.032 0 0 0 8 8h294.425a8.032 8.032 0 0 0 8-8v-74.7l-49.371 26.715zm-214.744.968h183.407a8 8 0 1 0 0-16H80.322a8 8 0 1 0 0 16zM333.138 84.7l-39.486-39.436V76.7a8.033 8.033 0 0 0 8 8z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayorEnrollmentWhite);
export default __webpack_public_path__ + "static/media/Payor-Enrollment-White.f8446e4fad9d77d1c8c0c22bf80e77ef.svg";
export { ForwardRef as ReactComponent };